import { ChangedItem } from '@/types';
import { intersection, union, without } from 'lodash-es';

const defaultComparer = (a: any, b: any) => a === b;
export function arrayReplaceMany<T>(
    array: T[],
    changes: ChangedItem<T>[],
    comparer: (a: T, b: T) => boolean = defaultComparer
): T[] {
    return array.map((item) => {
        const change = changes.find((x) => comparer(item, x.original));
        if (change) {
            return change.modified;
        }

        return item;
    });
}

export function arraySwap(array: any[], index1: number, index2: number) {
    const item1 = array[index1];
    const item2 = array[index2];

    array[index2] = item1;
    array[index1] = item2;
}

export function arrayGroupBy<T, TKey, TValue = T>(
    data: T[],
    keySelector: (item: T) => TKey,
    valueSelector: (item: T) => TValue
): Map<TKey, TValue[]> {
    const map = new Map<TKey, TValue[]>();

    data.forEach((element) => {
        const key = keySelector(element);

        const currentGroup: TValue[] = map.get(key) ?? [];

        const newGroup = [...currentGroup, valueSelector(element)];

        map.set(key, newGroup);
    });

    return map;
}

export function checkSubsetSelection<T>(selection: T[], data: T[]) {
    const selectionCount = intersection(selection, data).length;

    if (selectionCount === data.length) {
        return 'all';
    }

    if (selectionCount === 0) {
        return 'none';
    }

    return 'some';
}

export function toggleArrayValues<T>(data: T[], itemsToChange: T[], flag: boolean) {
    if (flag) {
        return union(data, itemsToChange);
    } else {
        return without(data, ...itemsToChange);
    }
}
